<template>
  <div>

    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      DETALLE INDICE
    </p>

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >Detalle Indice
          <span v-if="indice">{{ indice.Name.es }}</span></v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn depressed color="secondary" @click="irAddDataIndice"
          >Agregar Fuente de Datos</v-btn
        >

        <!-- <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-apps</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>-->
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col v-if="indice" cols="12">
            <h2 class="mb-3">{{ indice.Name.es }}</h2>
            <!-- <p class="mb-2">{{ indice.Id }}</p> -->
            <p class="mb-0">{{ indice.Description.es }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Id Ubicación</th>
                    <th class="text-center">Valor Actual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dataIndice" :key="item.Id">
                    <td class="text-center">{{ item.IdUbication }}</td>
                    <td class="text-center">{{ item.Value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "Indices",
  data() {
    return {
      idIndice: null,
      indice: null,
      dataIndice: [],
    };
  },
  mounted() {
    const idIndice = this.$route.params.idIndice;
    this.idIndice = idIndice;
    this.getIndice(idIndice);
    this.getDataIndice(idIndice);
  },
  methods: {
    async getIndice(idIndice) {
      try {
        const data = await api.getIndice(idIndice);

        if (data.status) {
          this.indice = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getDataIndice(idIndice) {
      try {
        const data = await api.getDataIndice(idIndice);

        if (data.status) {
          // console.log(data.data);
          this.dataIndice = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    irAddDataIndice() {
      this.$router.push(`/admin/indices/${this.idIndice}/upload-data`);
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>
